export default {
  404: 'No se han podido encontrar las materias',
  411: 'No se encontró la carrera específicada',
  418: 'Una o más especialidades no existen en la carrera específicada',
  427: 'La clave ya se encuentra registrada',
};
